import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ConditionWithCounter } from "components/Layout/Campaign/Common/CampaignRules/Rule/CommandBar/CommandBar";
import { CampaignBEData, CampaignFEValues } from "types/campaigns";

export interface InitialState {
  imported: (CampaignBEData | CampaignFEValues)[];
  popularConditions: ConditionWithCounter[];
}

const initialState: InitialState = {
  imported: [],
  popularConditions: [],
};

export const campaignsSlice = createSlice({
  name: "campaigns",
  initialState,
  reducers: {
    setImportedCampaigns: (
      state,
      action: PayloadAction<(CampaignBEData | CampaignFEValues)[]>,
    ) => {
      state.imported = action.payload;
    },
    updateImportedCampaigns: (
      state,
      action: PayloadAction<{
        importedId: number;
        campaign: CampaignBEData;
      }>,
    ) => {
      state.imported = state.imported.map((campaign, index) => {
        if (index === action.payload.importedId) {
          return action.payload.campaign;
        }

        return campaign;
      });
    },
    setPopularConditions: (
      state,
      action: PayloadAction<{ popularConditions: ConditionWithCounter[] }>,
    ) => {
      state.popularConditions = action.payload.popularConditions;
    },
  },
});

export const {
  setImportedCampaigns,
  updateImportedCampaigns,
  setPopularConditions,
} = campaignsSlice.actions;

export const selectImportedCampaigns = (state: RootState) =>
  state.campaigns.imported;

export const selectPopularConditions = (state: RootState) =>
  state.campaigns.popularConditions;

export default campaignsSlice.reducer;
